import React from 'react'
import withStyles from 'constructicon/with-styles'

const AddressResult = ({ classNames, result }) => (
  <div className={classNames.root}>
    <div className={classNames.content}>
      <input type='radio' />
      {result.label}
    </div>
  </div>
)

const styles = ({ isActive }, { colors, rhythm, scale }) => ({
  root: {
    position: 'relative',
    padding: rhythm(0.25),
    fontSize: scale(-0.5),
    cursor: 'pointer',

    '&:before': {
      content: isActive && '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: colors.lightGrey
    }
  },

  content: {
    position: 'relative',
    paddingLeft: rhythm(1),
    lineHeight: 1.5,

    '& input': {
      position: 'absolute',
      left: 0,
      top: '0.25rem',
      cursor: 'pointer'
    }
  }
})

export default withStyles(styles)(AddressResult)
